/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
  useRouteError
} from 'react-router-dom';
import { BaseLayout } from '@/layouts';
import PrivateRoute from './PrivateRoute';

const Dashboard = lazy(() => import('@/views/Dashboard'));
const Login = lazy(() => import('@/views/Login'));
const NotFound = lazy(() => import('@/views/NotFound'));
const Reports = lazy(() => import('@/views/Reports'));
const ReportDetails = lazy(() => import('@/views/ReportDetails'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={lazyView(<Dashboard />)} />
          <Route path="/reports/:productId" element={lazyView(<Reports />)} />
          <Route
            path="/reports/:productId/:reportId/details"
            element={lazyView(<ReportDetails />)}
          />
        </Route>
      </Route>
      <Route path="/login" element={lazyView(<Login />)} />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
